import {
  actionDescriptionLocoKeys,
  actionTitleLocoKeys,
} from 'modules/automation-rules/actions/constants/action-loco-keys'
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum'
import { getActionIcon } from 'modules/automation-rules/actions/utils/get-action-icon'
import type { JSX } from 'react'

const actionCategoryLocoKeys = {
  communication: 'dashboard.automation_rule.category.communication',
  crm: 'dashboard.automation_rule.category.crm',
  courses: 'dashboard.automation_rule.category.courses',
  community: 'dashboard.automation_rule.category.community',
  integrations: 'dashboard.automation_rule.category.integrations',
} as const

export const actionCategoryOrder = Object.values(actionCategoryLocoKeys)

type ActionCategory = (typeof actionCategoryLocoKeys)[keyof typeof actionCategoryLocoKeys]

const actionCategoryBySlug = {
  [AutomationRuleActionsEnum.subscribe_to_campaign]: actionCategoryLocoKeys.communication,
  [AutomationRuleActionsEnum.unsubscribe_from_campaign]: actionCategoryLocoKeys.communication,
  [AutomationRuleActionsEnum.send_email]: actionCategoryLocoKeys.communication,
  [AutomationRuleActionsEnum.send_email_to_specific_address]: actionCategoryLocoKeys.communication,
  [AutomationRuleActionsEnum.send_sms]: actionCategoryLocoKeys.communication,
  [AutomationRuleActionsEnum.add_tag]: actionCategoryLocoKeys.crm,
  [AutomationRuleActionsEnum.remove_tag]: actionCategoryLocoKeys.crm,
  [AutomationRuleActionsEnum.assign_to_pipeline_stage]: actionCategoryLocoKeys.crm,
  [AutomationRuleActionsEnum.create_user]: actionCategoryLocoKeys.crm,
  [AutomationRuleActionsEnum.create_white_label_user]: actionCategoryLocoKeys.crm,
  [AutomationRuleActionsEnum.enroll_in_course]: actionCategoryLocoKeys.courses,
  [AutomationRuleActionsEnum.revoke_access_to_course]: actionCategoryLocoKeys.courses,
  [AutomationRuleActionsEnum.enroll_in_course_bundle]: actionCategoryLocoKeys.courses,
  [AutomationRuleActionsEnum.revoke_access_to_course_bundle]: actionCategoryLocoKeys.courses,
  [AutomationRuleActionsEnum.grant_access_to_community]: actionCategoryLocoKeys.community,
  [AutomationRuleActionsEnum.revoke_access_to_community]: actionCategoryLocoKeys.community,
  [AutomationRuleActionsEnum.send_webhook]: actionCategoryLocoKeys.integrations,
} satisfies Record<AutomationRuleActionsEnum, ActionCategory>

export interface ActionItem {
  category: ActionCategory
  slug: AutomationRuleActionsEnum
  title: string
  description: string
  icon: JSX.Element
}

export const actionItems: ActionItem[] = Object.values(AutomationRuleActionsEnum).map(slug => ({
  category: actionCategoryBySlug[slug],
  slug: slug,
  title: actionTitleLocoKeys[slug],
  description: actionDescriptionLocoKeys[slug],
  icon: getActionIcon(slug),
}))
